/**作品路由 */
export default [
    {
        name:'works',
        path:'works',
        meta: { title: '账户管理' },
        component: ()=>import('@/pages/works/index.vue')
    }
]